const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

// 接口统计
const apiStatistics = r =>
  require.ensure(
    [],
    () => r(require('@/modules/statistics/apiStatistics.vue')),
    'statistics'
  )

// 调用详情
const callDetails = r =>
  require.ensure(
    [],
    () => r(require('@/modules/statistics/callDetails.vue')),
    'statistics'
  )

const statisticsConfig = {
  path: '/statistics',
  name: 'statistics',
  component: Layout,
  meta: {
    auth: true,
    id: 'ba68c9c2c64d42c6a71fd1d08f473f4a',
    breadcrumbShow: true
  },
  redirect: '/statistics/apiStatistics',
  children: [
    {
      path: '/statistics/apiStatistics',
      name: 'apiStatistics',
      component: apiStatistics,
      meta: {
        id: '2f781f0bc6dc4367b70fa4946784c4c5',
        auth: true
      }
    },
    {
      path: '/statistics/callDetails',
      name: 'statisticsCallDetails',
      component: callDetails,
      meta: {
        id: 'c6174c6640fc4bf5aa1957b5b4b3cce0',
        auth: true
      }
    }
  ]
}
export default statisticsConfig



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/statistics.js